<!--suppress ALL -->

<template>
	<tr>
		<td class="text-xs-center">
			{{branch.name }}
		</td>
		<td class="text-xs-center">
			{{branch.directory_name }}
		</td>
		<td class="text-xs-center">
			{{branch.address }}
		</td>
		<td class="text-xs-center">
			{{branch.postal }}
		</td>
		<td class="text-xs-center">
			{{branch.city }}
		</td>

		<td class="text-xs-center">
			{{branch.tel }}
		</td>
		<td class="text-xs-center">
			{{branch.contact_man }}
		</td>
		<td class="text-xs-center">
			{{branch.email }}
		</td>
		<td>
			<edit-btn @click="onEdit" :tooltip-text="$t('attributes.edit')"/>
			<remove-btn :tooltip-text="$t('attributes.remove')" />
		</td>

	</tr>
</template>

<script>

	import {types} from "src/store/modules/Branch.module";
	import {types as clientTypes} from "src/store/modules/Client.module";
	import RemoveBtn from "src/scaffoldings/RemoveBtn";
	import EditBtn from "src/scaffoldings/EditBtn";
	import RowMixin from "src/mixins/RowMixin";

	export default {
		name: "branch-row",
		props: {
			branch: {required: true}
		},
		components: {EditBtn, RemoveBtn},
		mixins: [new RowMixin(types, "branch")],
		data() {
			return {};
		},
		computed: {},
		methods: {
			onRemove() {
				this.$store.dispatch(types.REMOVE, this.branch).then(() => {
					this.$store.commit(clientTypes.REMOVE_SUB_MODEL, {
						name: "branches",
						id: this.branch.client_id,
						model: this.branch
					});
				});
			},
			onEdit() {
				this.$emit("edit", this.branch);
			}
		}
	};
</script>

<style>


</style>
